module.exports = __webpack_public_path__ + "img/dialog2.a136fb5b.png";